/**
 * The NAICS pieces the search builder and chips need, without the 2,125-code
 * list (naics-codes.ts), which loads with the NAICS pickers instead of with
 * every page.
 */

/** The `[low, high)` string range a shorter NAICS code covers, or null for a
 *  six-digit code: "5412" covers every 5412xx, "31-33" covers 31 to 33. */
export function naicsCodeRange(code: string): [string, string] | null {
  if (code.length === 6) return null;
  const [low, high] = code.split('-');
  return [low, String(Number(high ?? low) + 1)];
}

const titles = new Map<string, string>();

/** Fills the titles chips show; naics-codes.ts calls it when it loads. */
export function registerNaicsTitles(
  codes: ReadonlyArray<{ code: string; title: string }>
): void {
  for (const { code, title } of codes) titles.set(code, title);
}

/** "541213 Tax Preparation Services", or the bare code before the list has
 *  loaded (it loads with the NAICS pickers on the search pages). */
export function naicsLabel(code: string): string {
  const title = titles.get(code);
  return title ? `${code} ${title}` : code;
}
